(function () {

  var mainImage = document.getElementById('product-main-image');
  var thumbnails = document.querySelectorAll('[data-thumbnail]');

  // Gallery thumbnail click — swap main image
  if (mainImage && thumbnails.length > 0) {
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var imageUrl = this.getAttribute('data-image-url');
        var imageAlt = this.getAttribute('data-image-alt') || '';

        mainImage.src = imageUrl;
        mainImage.alt = imageAlt;

        thumbnails.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  }

  // Quantity stepper
  var quantityInput = document.querySelector('.quantity-input');
  var decrementBtn = document.querySelector('[data-quantity-decrement]');
  var incrementBtn = document.querySelector('[data-quantity-increment]');

  if (quantityInput && decrementBtn && incrementBtn) {
    decrementBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var current = parseInt(quantityInput.value, 10) || 1;
      quantityInput.value = Math.max(1, current - 1);
    });

    incrementBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var current = parseInt(quantityInput.value, 10) || 1;
      // TODO: clamp to variant inventory_quantity when inventory_policy === 'deny'
      // Requires adding inventory_quantity + inventory_policy to window.productVariants in product.liquid
      quantityInput.value = current + 1;
    });

    quantityInput.addEventListener('change', function () {
      var val = parseInt(this.value, 10);
      if (isNaN(val) || val < 1) this.value = 1;
    });
  }

  // Variant select — update price display, availability, and main image
  var variantSelect = document.getElementById('variant-select');
  var addToCartBtn = document.getElementById('add-to-cart-btn');
  var priceEl = document.getElementById('product-price');
  var compareEl = document.getElementById('product-compare-price');
  var variants = window.productVariants || {};

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var data = variants[this.value];
      if (!data) return;

      // Update price
      if (priceEl) priceEl.textContent = formatMoney(data.price);

      // Update compare-at price
      if (compareEl) {
        if (data.compareAtPrice && data.compareAtPrice > data.price) {
          compareEl.textContent = formatMoney(data.compareAtPrice);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // Update Add to Cart availability
      if (addToCartBtn) {
        if (data.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Sold Out';
        }
      }

      // Swap main image if variant has a specific image
      if (mainImage && data.featuredImageSrc) {
        mainImage.src = data.featuredImageSrc;
        mainImage.alt = data.featuredImageAlt || '';

        thumbnails.forEach(function (thumb) {
          thumb.classList.remove('active');
          if (thumb.getAttribute('data-image-url') === data.featuredImageSrc) {
            thumb.classList.add('active');
          }
        });
      }
    });
  }

  // Form submit — AJAX add to cart
  var form = document.getElementById('product-form');

  if (form && addToCartBtn) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var variantId = form.querySelector('[name="id"]').value;
      var quantity = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;

      addToCartBtn.classList.add('loading');
      addToCartBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Could not add to cart'); });
          return res.json();
        })
        .then(function () {
          addToCartBtn.textContent = 'Added!';
          addToCartBtn.classList.remove('loading');
          updateCartCount();
          setTimeout(function () {
            addToCartBtn.textContent = 'Add to Cart';
            addToCartBtn.disabled = false;
          }, 2000);
        })
        .catch(function (err) {
          addToCartBtn.textContent = err.message || 'Error — try again';
          addToCartBtn.classList.remove('loading');
          addToCartBtn.disabled = false;
          setTimeout(function () {
            addToCartBtn.textContent = 'Add to Cart';
          }, 3000);
        });
    });
  }

  // Refresh cart count badge in the nav
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  // Format money using Shopify's money_format
  function formatMoney(cents) {
    if (cents === null || cents === undefined) return '';
    var format = (window.Shopify && window.Shopify.moneyFormat) || '&#36;{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(cents / 100));
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals);
  }

})();
